'use client';

import { c as _c } from "react/compiler-runtime";
import { useApi } from '@repo/api';
import { HistoryDataController, type HistoryQueryOptionsFacade, HistorySkeleton } from '@repo/features/history';
import { Suspense } from 'react';
import { companyHistoryEntity } from './company-history-entity.ts';
export type CompanyHistoryProps = {
  companyId: number;
};
export const CompanyHistory = t0 => {
  const $ = _c(6);
  const {
    companyId
  } = t0;
  const api = useApi();
  let t1;
  if ($[0] !== api) {
    t1 = {
      filters: id => api.companies.history.filters.queryOptions({
        path: {
          id
        }
      }),
      list: t2 => {
        const {
          id: id_0,
          ...input
        } = t2;
        return api.companies.history.list.queryOptions({
          input: {
            ...input,
            perPage: 50
          },
          path: {
            id: id_0
          }
        });
      }
    };
    $[0] = api;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const queryOptions = t1;
  let t2;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = <HistorySkeleton />;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  let t3;
  if ($[3] !== companyId || $[4] !== queryOptions) {
    t3 = <Suspense fallback={t2} data-sentry-element="Suspense" data-sentry-component="CompanyHistory" data-sentry-source-file="company-history.tsx"><HistoryDataController entity={companyHistoryEntity} id={companyId} key={companyId} queryOptions={queryOptions} data-sentry-element="HistoryDataController" data-sentry-source-file="company-history.tsx" /></Suspense>;
    $[3] = companyId;
    $[4] = queryOptions;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  return t3;
};